import { authorizationManagerService } from '@/services';
import Vue from 'vue';

Vue.prototype.$isCommercial = () => authorizationManagerService.isCommercial;
